import { Descriptions, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { NetworkResult } from '../../common/CommonResult';
import { API } from '../../api';
interface Props {
  visible: boolean;
  item?: any;
  onClose: () => void;
}
const DraftParcelDetail = ({ visible, item, onClose }: Props) => {
  const [state, changeState] = useState<NetworkResult<any>>({
    loading: true,
    result: {},
  });
  useEffect(() => {
    if (visible && item) {
      fetchContent(item);
    }
  }, [visible, item]);
  const fetchContent = async (filter: any) => {
    try {
      changeState({ loading: true, result: {} });
      const response = await API.get({ apiVersion: 'api' })(`/order_draft/parcel/${filter}`);
      changeState({ loading: false, result: response.result });
    } catch (e) {
      changeState({ loading: false, error: true, result: {}, errors: e });
    }
  };
  return (
    <Modal open={visible} title="Уридчилсан захиалгын дэлгэрэнгүй" onCancel={onClose}>
      <Descriptions title="sdf">
        <Descriptions.Item label="trackingNumber">
          {state?.result?.trackingNumber}
        </Descriptions.Item>
        <Descriptions.Item label="orderNumber">{state?.result?.orderNumber}</Descriptions.Item>
      </Descriptions>
      <Descriptions title="Хүлээн авагч">
        <Descriptions.Item label="name">
          {state.result?.receiverLname}-{state.result?.receiverFname}
        </Descriptions.Item>
        <Descriptions.Item label="phone">{state.result?.receiverPhone}</Descriptions.Item>
        <Descriptions.Item label="Address">
          {state.result?.receiverProvince}-{state.result?.receiverDistrict}-
          {state.result?.receiverSubdistrict}
        </Descriptions.Item>
        <Descriptions.Item label="Zipcode">{state.result?.receiverPostalcode}</Descriptions.Item>
        <Descriptions.Item label="AddressDetail">
          {state.result?.receiverAddress1}-{state.result?.receiverAddress2}
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};
export default DraftParcelDetail;
